/* ================== THE PURSER · client bridge ==================
   Coins and tickets belong to the account, not the browser.

   When a visitor is signed in, this takes over from the local wallet:
   the coin box asks the server before a paid play, the ticket rail asks
   the server to award and to claim, and the balance follows them to any
   device they sign in on.

   When they are NOT signed in, nothing changes — the local wallet keeps
   working exactly as before, so a stranger can still walk in and play
   the free rotation without an account. Their local balance is offered
   up to the server the first time they sign in.

   Everything goes through the shop's own /apps/station App Proxy, so the
   request is signed by Shopify and the browser never holds a secret.
   ================================================================ */
(function () {
  if (window.STATION_PURSER) return;

  var BASE = window.STATION_PURSER_BASE || '/apps/station';
  var state = { signedIn: false, coins: 0, tickets: 0, claims: [], log: [], ready: false, online: false };

  function bus() { try { window.dispatchEvent(new CustomEvent('purser')); } catch (e) {} }

  function call(path, body) {
    var opts = { credentials: 'same-origin', headers: { 'content-type': 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(BASE + path, opts)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ---- pull the purse once on load ---- */
  function refresh() {
    return call('/balance').then(function (r) {
      state.ready = true;
      if (!r) { state.online = false; bus(); return state; }
      state.online = true;
      state.signedIn = !!r.signedIn;
      if (r.signedIn) {
        state.coins = r.coins | 0;
        state.tickets = r.tickets | 0;
        state.claims = r.claims || [];
        state.log = r.log || [];
      }
      bus();
      return state;
    });
  }

  /* ---- take over the coin box and the ticket rail ---- */
  function graft() {
    var CB = window.STATION_COINBOX, T = window.STATION_TICKETS;

    if (CB && !CB.__pursed) {
      CB.__pursed = true;
      var localTokens = CB.tokens, localSpend = CB.spend;
      CB.tokens = function () { return state.signedIn ? state.coins : localTokens(); };
      CB.spend = function (id) {
        if (!state.signedIn) return localSpend(id);
        if (state.coins < 1) return false;
        state.coins -= 1;                       /* optimistic — the server is the truth */
        bus();
        call('/spend', { game: id }).then(function (r) {
          if (r && typeof r.coins === 'number') { state.coins = r.coins; bus(); }
          else refresh();
        });
        return true;
      };
    }

    if (T && !T.__pursed) {
      T.__pursed = true;
      var localBalance = T.balance, localAward = T.award, localClaim = T.claim;
      T.balance = function () { return state.signedIn ? state.tickets : localBalance(); };
      T.award = function (game, score, best) {
        if (!state.signedIn) return localAward(game, score, best);
        var guess = Math.max(1, 2 + Math.min(10, Math.floor((Number(score) || 0) / Math.max(1, Number(best) || 100) * 8)));
        state.tickets += guess; bus();
        call('/award', { game: game, score: score, best: best }).then(function (r) {
          if (r && typeof r.tickets === 'number') { state.tickets = r.tickets; bus(); }
          else refresh();
        });
        return guess;
      };
      T.claim = function (prize, cost) {
        if (!state.signedIn) return localClaim(prize, cost);
        var need = T.price(cost);
        if (state.tickets < need) return { ok: false, need: need, have: state.tickets };
        /* a claim is real inventory — never optimistic, always the server's answer */
        return call('/claim', { prize: prize, cost: cost }).then(function (r) {
          if (!r) return { ok: false, need: need, have: state.tickets };
          if (r.ok) { state.tickets = r.tickets | 0; state.claims.unshift({ code: r.code, prize: prize, tickets: r.spent, at: Date.now() }); bus(); }
          return r;
        });
      };
      T.claimIsAsync = function () { return state.signedIn; };
    }
  }

  window.STATION_PURSER = {
    state: function () { return JSON.parse(JSON.stringify(state)); },
    signedIn: function () { return state.signedIn; },
    coins: function () { return state.coins; },
    tickets: function () { return state.tickets; },
    claims: function () { return state.claims; },
    log: function () { return state.log; },
    refresh: refresh
  };

  graft();
  refresh();
  /* the coin box or ticket rail may load after this file — graft again once */
  setTimeout(graft, 400);
  window.addEventListener('coinbox', function () {});
})();
